var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#213B54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6666 20.2733L27.7266 19.3333L23.9999 23.0599L20.2733 19.3333L19.3333 20.2733L23.0599 23.9999L19.3333 27.7266L20.2733 28.6666L23.9999 24.9399L27.7266 28.6666L28.6666 27.7266L24.9399 23.9999L28.6666 20.2733Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIcon);
export default __webpack_public_path__ + "static/media/activeIcon.4fc70a135daa01cccfde5cf567462acc.svg";
export { ForwardRef as ReactComponent };